export enum Environment {
  NONPROD = 'nonprod',
  PROD = 'prod',
}

export enum VariantValues {
  WhUkXsell = 'wh-uk-xsell',
  WhUkVegas = 'wh-uk-vegas',
  WhItXsell = 'wh-it-xsell',
  WhItVegas = 'wh-it-vegas',
  WhItCasino = 'wh-it-casino',
  WhEsXsell = 'wh-es-xsell',
  WhEsVegas = 'wh-es-vegas',
}

export type Variant = VariantValues;

export interface AssemblerContext {
  locale: string;
  default_currency: string;
  viewer_country: string;
  viewer_region: string;
  host: string;
  base_path: string;
  market_id: string;
  version: string;
  is_native: string;
}
